import { useState } from "react";

import styles from "./year-filter.module.css";

type YearFilterProps = {
  currentYear: number;
  selectedYears: number[];
  onChange: (years: number[]) => void;
};

export const YearFilter = ({
  currentYear,
  selectedYears,
  onChange,
}: YearFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const years = Array.from(
    { length: 12 },
    (_, index) => currentYear - index
  ).reverse();

  const toggleYear = (year: number) => {
    if (selectedYears.includes(year)) {
      const newYears = selectedYears.filter((selected) => selected !== year);

      if (newYears.length === 0) {
        onChange([currentYear]);
        return;
      }

      onChange(newYears);
    } else {
      onChange([...selectedYears, year].sort((a, b) => b - a));
    }
  };

  const handlePreviousYear = () => {
    const currentSelectedYear = Math.min(...selectedYears);

    if (currentSelectedYear > 1) {
      onChange([currentSelectedYear - 1]);
    }
  };

  const handleNextYear = () => {
    const currentSelectedYear = Math.max(...selectedYears);

    if (currentSelectedYear < currentYear) {
      onChange([currentSelectedYear + 1]);
    }
  };

  return (
    <div className={styles["year-filter"]}>
      <button className={styles["year-button"]} onClick={handlePreviousYear}>
        <img alt="left arrow" src="/img/left.png" />
      </button>

      <div>
        <button
          className={styles["year-button"]}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {selectedYears.length === 1
            ? selectedYears[0]
            : `${Math.min(...selectedYears)} - ${Math.max(...selectedYears)}`}
        </button>

        {isOpen && (
          <div className={styles["year-popup"]}>
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={`${styles["year-option"]} ${
                  selectedYears.includes(year) ? styles["selected"] : ""
                }`}
                onClick={() => toggleYear(year)}
              >
                {year}
              </button>
            ))}
          </div>
        )}
      </div>
      <button className={styles["year-button"]} onClick={handleNextYear}>
        <img alt="right arrow" src="/img/right.png" />
      </button>
    </div>
  );
};
